import { TFunction } from 'i18next';

export enum BadgeEnum {
    AWARD_WINNER,
    NEW_RELEASE,
    LONG_QUEUE,
    LONGER_SHIPPING,
    MISSING_IN_SERIES,
    HIDDEN_PRODUCT
}

export const mapBadgeByKey = (t: TFunction, badgeKey: BadgeEnum, title: string) => {
    switch (badgeKey) {
        case BadgeEnum.AWARD_WINNER:
            return t('components.badges.awardWinner', {
                defaultValue: title
            });
        case BadgeEnum.NEW_RELEASE:
            return t('components.badges.newRelease', {
                defaultValue: title
            });
        case BadgeEnum.LONG_QUEUE:
            return t('components.badges.longQueue', {
                defaultValue: title
            });
        case BadgeEnum.LONGER_SHIPPING:
            return t('components.badges.longerShipping', {
                defaultValue: title
            });
        case BadgeEnum.MISSING_IN_SERIES:
            return t('components.badges.missingInSeries', {
                defaultValue: title
            });
        case BadgeEnum.HIDDEN_PRODUCT:
            return t('components.badges.hiddenProduct', {
                defaultValue: title
            });
        default:
            return title;
    }
};

export const mapBadgeByTitle = (t: TFunction, title: string) => {
    switch (title) {
        case '#1 bestselling author':
            return t('filters:bestseller.#1 bestselling author', {
                defaultValue: title
            });
        case '#1 bestselling mystery writer':
            return t('filters:bestseller.#1 bestselling mystery writer', {
                defaultValue: title
            });
        case '#1 New York Times bestseller':
            return t('filters:bestseller.#1 New York Times bestseller', {
                defaultValue: title
            });
        case '#1 New York Times bestselling author':
            return t('filters:bestseller.#1 New York Times bestselling author', {
                defaultValue: title
            });
        case '#1 New York Times bestselling series':
            return t('filters:bestseller.#1 New York Times bestselling series', {
                defaultValue: title
            });
        case '#1 UK Bestseller':
            return t('filters:bestseller.#1 UK Bestseller', {
                defaultValue: title
            });
        case 'A National Bestseller':
            return t('filters:bestseller.A National Bestseller', {
                defaultValue: title
            });
        case 'Amazon bestseller':
            return t('filters:bestseller.Amazon bestseller', {
                defaultValue: title
            });
        case 'Bestseller':
            return t('filters:bestseller.Bestseller', {
                defaultValue: title
            });
        case 'Bestselling author':
            return t('filters:bestseller.Bestselling author', {
                defaultValue: title
            });
        case 'Bestselling series':
            return t('filters:bestseller.Bestselling series', {
                defaultValue: title
            });
        case 'International bestseller':
            return t('filters:bestseller.International bestseller', {
                defaultValue: title
            });
        case 'International bestselling author':
            return t('filters:bestseller.International bestselling author', {
                defaultValue: title
            });
        case 'International bestselling series':
            return t('filters:bestseller.International bestselling series', {
                defaultValue: title
            });
        case 'National bestselling author':
            return t('filters:bestseller.National bestselling author', {
                defaultValue: title
            });
        case 'New York Times bestseller':
            return t('filters:bestseller.New York Times bestseller', {
                defaultValue: title
            });
        case 'New York Times bestselling author':
            return t('filters:bestseller.New York Times bestselling author', {
                defaultValue: title
            });
        case 'New York Times bestselling series':
            return t('filters:bestseller.New York Times bestselling series', {
                defaultValue: title
            });
        case 'Sunday Times bestseller':
            return t('filters:bestseller.Sunday Times bestseller', {
                defaultValue: title
            });
        case 'Sunday Times bestselling author':
            return t('filters:bestseller.Sunday Times bestselling author', {
                defaultValue: title
            });
        case 'The Sunday Times bestseller':
            return t('filters:bestseller.The Sunday Times bestseller', {
                defaultValue: title
            });
        case 'USA Today bestseller':
            return t('filters:bestseller.USA Today bestseller', {
                defaultValue: title
            });
        case 'USA Today bestselling author':
            return t('filters:bestseller.USA Today bestselling author', {
                defaultValue: title
            });
        case 'USA Today bestselling series':
            return t('filters:bestseller.USA Today bestselling series', {
                defaultValue: title
            });
        default:
            return t(`filters:bestseller.${title}`, {
                defaultValue: title
            });
    }
};
